<template>
  <div class="list reserved-page">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>外教招聘</Breadcrumb-item>
        <Breadcrumb-item>储备老师</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false" label-position="right">
        <Row type="flex" :gutter="16">
          <Col :span="6">
            <Form-item label="ID/姓名">
              <Input v-model="queryParam.keyword" placeholder="老师ID / 姓名 / 邮箱"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="国籍">
              <Input v-model="queryParam.nationality" placeholder="国籍"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="渠道">
              <Select v-model="queryParam.regFrom" placeholder="全部" clearable>
                <Option v-for="item in channelOptions" :value="item.param" :key="item.id">{{ item.status === 0 ? (item.name + '（停用）') : item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="HR">
              <Select v-model="queryParam.hr" placeholder="全部" clearable>
                <Option v-for="item in $constant.hrList" :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item :label-width="20">
              <Button type="primary" icon="search" :loading="loading" @click="search">搜索</Button>
              <Button style="margin-left: 8px" @click="reset">重置</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <Table border stripe :columns="columns" :data="tableData" :loading="loading"></Table>
    <Page class="page" :total="totalCount" :current="pageIndex" :page-size="pageSize" show-total show-sizer
      show-elevator :page-size-opts="[10, 20, 50, 100]" placement="top"
      @on-change="onPageChange" @on-page-size-change="onPageSizeChange"></Page>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal = false" :tchId="tchId" :showTchSelf="true"
      :successCallback="loadList" recruit-flow-entry="储备老师"></tch-info-modal>
  </div>
</template>
<script>
import TchInfoModal from '../modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import { tchName } from './recruitConst'

function emptyQuery () {
  return {
    keyword: '',
    nationality: '',
    regFrom: '',
    hr: ''
  }
}

export default {
  name: 'TchReservedList',
  components: { TchInfoModal },
  data () {
    return {
      channelOptions: [],
      queryParam: emptyQuery(),
      appliedQuery: {},
      loading: false,
      rankScoreSeq: 0,
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      showTchInfoModal: false,
      tchId: null,
      columns: [
        {title: '老师ID', key: 'tchId', width: 90, align: 'center'},
        {
          title: '姓名',
          minWidth: 140,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: tchName(row) || String(row.tchId),
              score: row.monthRankScore,
              onClick: () => this.openTchInfoModal(row.tchId)
            })
          }
        },
        {title: '国籍', key: 'nationality', width: 110, align: 'center'},
        {title: '渠道', key: 'regFrom', width: 110, align: 'center'},
        {
          title: '推荐人',
          width: 110,
          align: 'center',
          render: (h, params) => h('span', params.row.inviteTchName || '—')
        },
        {title: 'HR', key: 'hr', width: 100, align: 'center'},
        {
          title: '中断环节',
          width: 120,
          align: 'center',
          render: (h, params) => h('span', params.row.reserveFrom || '—')
        },
        {
          title: '储备原因',
          minWidth: 180,
          render: (h, params) => {
            let reason = params.row.reserveReason || ''
            return h('div', {
              attrs: {title: reason},
              style: {overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}
            }, reason || '—')
          }
        },
        {title: '转入时间', key: 'reserveTime', width: 160, align: 'center'},
        {
          title: '操作',
          width: 140,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h('a', {on: {click: () => this.reactivate(row)}}, '重新激活'),
              h('span', {class: 'divider'}),
              h('a', {style: {color: '#ed3f14'}, on: {click: () => this.archive(row)}}, '归档')
            ])
          }
        }
      ]
    }
  },
  created () {
    this.loadRegChannels()
    this.search()
  },
  methods: {
    loadRegChannels () {
      this.$http.get('/tch/reg-channel/options').then((res) => {
        if (res && res.status === 'ok' && res.data) {
          this.channelOptions = res.data
        }
      }).catch(() => {})
    },
    buildQuery () {
      let q = {}
      let src = this.queryParam
      Object.keys(src).forEach(function (k) {
        let v = src[k]
        if (v !== null && v !== undefined && String(v).trim() !== '') {
          q[k] = String(v).trim()
        }
      })
      return q
    },
    search () {
      this.appliedQuery = this.buildQuery()
      this.pageIndex = 1
      this.loadList()
    },
    reset () {
      this.queryParam = emptyQuery()
      this.search()
    },
    loadList () {
      let params = Object.assign({}, this.appliedQuery, {
        pageNum: this.pageIndex,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      })
      this.loading = true
      this.$http.post('/tchRecruit/reserve/list', params, {silent: true}).then((res) => {
        if (res && res.status === 'ok') {
          let data = res.data || {}
          this.tableData = data.data || []
          this.loadMonthRankScores()
          this.totalCount = data.totalCount || 0
        } else {
          this.tableData = []
          this.totalCount = 0
          this.$Message.error((res && res.msg) || '列表加载失败')
        }
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    },
    onPageChange (page) {
      this.pageIndex = page
      this.loadList()
    },
    onPageSizeChange (size) {
      this.pageSize = size
      this.pageIndex = 1
      this.loadList()
    },
    loadMonthRankScores () {
      const rows = this.tableData || []
      if (!rows.length) {
        return
      }
      const ids = rows.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, rows, 'tchId', 'monthRankScore', map)
      })
    },
    openTchInfoModal (tchId) {
      this.tchId = Number(tchId)
      this.showTchInfoModal = true
    },
    action (url, row, successText) {
      this.$http.post(url, {tchId: row.tchId}, {silent: true}).then((res) => {
        if (res && res.status === 'ok') {
          this.$Message.success(successText)
          this.loadList()
          this.$root.$emit('recruit-badges-refresh')
        } else {
          this.$Message.error((res && res.msg) || '操作失败')
        }
      }).catch(() => {})
    },
    reactivate (row) {
      let name = tchName(row)
      this.$Modal.confirm({
        title: '重新激活',
        content: '确定将 ' + name + ' 重新激活回待面试？',
        onOk: () => this.action('/tchRecruit/reserve/reactivate', row, name + ' 已重新激活至待面试')
      })
    },
    archive (row) {
      let name = tchName(row)
      this.$Modal.confirm({
        title: '归档',
        content: '归档后 ' + name + ' 将从储备列表移除，确定归档？',
        onOk: () => this.action('/tchRecruit/reserve/archive', row, name + ' 已归档')
      })
    }
  }
}
</script>
<style scoped>
.reserved-page { padding: 20px; }
.breadcrumb { margin-bottom: 16px; }
.search { margin-bottom: 16px; padding: 16px 16px 0; border-radius: 4px; background: #f8f8f9; }
.page { margin-top: 12px; text-align: right; }
</style>



// WEBPACK FOOTER //
// TchReservedList.vue?340871ea